import React from 'react';
import { ChevronRight } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative w-full overflow-hidden pt-16 pb-24 lg:pt-24 lg:pb-32" data-id="element-87">
      {/* Background elements */}
      <div className="absolute inset-0 z-0" data-id="element-88">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#00E5FF]/5 rounded-full blur-3xl" data-id="element-89"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-[#B721FF]/5 rounded-full blur-3xl" data-id="element-90"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1639322537504-6427a16b0a28?q=80&w=3276&auto=format&fit=crop')] opacity-5 bg-cover bg-center mix-blend-overlay" data-id="element-91"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#0B0C10]/80" data-id="element-92"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-94">
          <div className="flex-1 text-center lg:text-left" data-id="element-95">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-['Orbitron'] leading-tight mb-6" data-id="element-96">
              <span className="block" data-id="element-97">From One Sentence</span>
              <span className="block bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text" data-id="element-98">
                to a Thriving App
              </span>
            </h1>
            <p className="text-lg md:text-xl text-[#F5F5F5]/80 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-99">
              You bring the idea — even if it's just one sentence. Nexoraq turns
              it into a market-ready app and stays with you until it becomes a
              success story.
            </p>
            <button className="px-8 py-4 bg-gradient-to-r from-[#00E5FF] to-[#B721FF] rounded-xl text-[#0B0C10] font-bold text-lg shadow-lg shadow-[#00E5FF]/20 hover:shadow-xl hover:shadow-[#00E5FF]/30 transition-all duration-300 flex items-center gap-2 mx-auto lg:mx-0" data-id="element-100">
              Start Your App Journey
              <ChevronRight size={20} data-id="element-101" />
            </button>
          </div>
          <div className="flex-1" data-id="element-102">
            <div className="relative" data-id="element-103">
              {/* App Development Process Visual */}
              <div className="bg-[#0B0C10]/50 backdrop-blur-sm border border-[#F5F5F5]/10 rounded-2xl p-6 shadow-xl shadow-[#00E5FF]/5" data-id="element-104">
                <div className="flex flex-col md:flex-row justify-between gap-4" data-id="element-105">
                  {[{
                  title: 'Idea',
                  icon: '💡'
                }, {
                  title: 'Blueprint',
                  icon: '🔍'
                }, {
                  title: 'Design',
                  icon: '🎨'
                }, {
                  title: 'Live App',
                  icon: '🚀'
                }].map((stage, index) => <div key={index} className="flex flex-col items-center" data-id="element-106">
                      <div className={`w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-3
                        ${index === 0 ? 'bg-gradient-to-r from-[#00E5FF] to-[#B721FF]' : 'bg-[#F5F5F5]/10'}`} data-id="element-107">
                        {stage.icon}
                      </div>
                      <p className={`text-sm font-medium ${index === 0 ? 'text-[#00E5FF]' : 'text-[#F5F5F5]/70'}`} data-id="element-108">
                        {stage.title}
                      </p>
                      {index < 3 && <div className="hidden md:block h-0.5 w-12 bg-gradient-to-r from-[#00E5FF]/50 to-transparent absolute left-[calc(25%*index+12.5%-6px+4rem*index)] top-8 translate-x-full" data-id="element-109"></div>}
                    </div>)}
                </div>
                <div className="mt-8 bg-[#0B0C10] border border-[#F5F5F5]/10 rounded-lg p-4" data-id="element-110">
                  <div className="flex items-center gap-3 mb-3" data-id="element-111">
                    <div className="w-3 h-3 rounded-full bg-[#00E5FF]" data-id="element-112"></div>
                    <div className="w-3 h-3 rounded-full bg-[#B721FF]" data-id="element-113"></div>
                    <div className="w-3 h-3 rounded-full bg-[#F5F5F5]/30" data-id="element-114"></div>
                  </div>
                  <div className="h-40 bg-[url('https://images.unsplash.com/photo-1618761714954-0b8cd0026356?q=80&w=3270&auto=format&fit=crop')] bg-cover bg-center rounded-md" data-id="element-115"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};